import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_containers/agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchContainer(customer_id, agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_templates/container/${agro_exporter_process_id}/${container_id}`
    );
  },

  downloadQualityInspectsRepXlsx(customer_id, container_id, quality_template_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_inspects/download_quality_inspects_rep_xlsx/${container_id}/${quality_template_id}`,
      { responseType: "blob" }
    );
  },

  fetchQualityInspects(customer_id, container_id, quality_template_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_inspects/${container_id}/${quality_template_id}`
    );
  },

  fetchQualityTemplate(customer_id, container_id, quality_template_id) {
    return RequesterV1.get(
      `customer/quality_control/query_container/${customer_id}/list_inspects/quality_template/${container_id}/${quality_template_id}`
    );
  }
};
